import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const YearOnlyFormat = "YYYY";
const YearMonthOnlyFormat = "YYYY-MM";
export const DateOnlyFormat = "YYYY-MM-DD";
export const DateTimeFormat = "DD MMM YYYY HH:mm:ss";
export const DateTimeFriendlyFormat = "DD MMM YYYY h:mma";
export const DateOnlyAusDateFormat = "DD/MM/YYYY";

export const formatDate = (date: string, format?: string): string => {
  return dayjs
    .utc(date)
    .local()
    .format(format || "DD MMM YYYY");
};

export const now = () => {
  return dayjs.utc();
};

export const toLocal = (date: dayjs.Dayjs) => {
  return date.local();
};

export const currentDate = () => {
  return dayjs.utc().toString();
};

export const dateFromString = (date: string) => {
  return dayjs.utc(date);
};

export const isBefore = (dateA: string, dateB: string) => {
  return dayjs.utc(dateA).isBefore(dayjs.utc(dateB));
};

export const isAfter = (dateA: string, dateB: string) => {
  return dayjs.utc(dateA).isAfter(dayjs.utc(dateB));
};

export const yearsAgo = (years: number) => {
  return dayjs.utc().subtract(years, "year");
};

export const toYearOnlyFormat = (date: string) => {
  return dayjs.utc(date).format(YearOnlyFormat);
};

export const toYearMonthOnlyFormat = (date: string) => {
  return dayjs.utc(date).format(YearMonthOnlyFormat);
};

export const toDateOnlyFormat = (date: string) => {
  return dayjs.utc(date).format(DateOnlyFormat);
};

export const dateToDateOnlyFormat = (date: dayjs.Dayjs) => {
  return date.format(DateOnlyFormat);
};

export const subtractDate = (
  date: string,
  value: number,
  unit: dayjs.ManipulateType
) => {
  return dayjs.utc(date).subtract(value, unit).toString();
};

export const endOfDay = (date: dayjs.Dayjs) => {
  return date.local().endOf("day");
};
